import React from "react";
import CustomerAnalyticsDataList from '../AnalyticsData/CustomerAnalyticsDataList';
import GiftCardsAnalyticsDataList from '../AnalyticsData/GiftCardsAnalyticsDataList';
import CustomerPhonesAnalyticsDataList from '../AnalyticsData/CustomerPhonesAnalyticsList';
import CustomerEmailsAnalyticsDataList from '../AnalyticsData/CustomerEmailsAnalyticsList';
import CashbackerCampaignRegistrationsAnalyticsDataList from '../AnalyticsData/CashbackerCampaignRegistrationsAnalyticsDataList';

export const CustomerAnalyticsList = (props) => (
  <CustomerAnalyticsDataList {...props}/>
);

export const GiftCardsAnalyticsList = (props) => (
  <GiftCardsAnalyticsDataList {...props}/>
);

export const CustomerPhonesAnalyticsList = (props) => (
  <CustomerPhonesAnalyticsDataList {...props}/>
);

export const CustomerEmailsAnalyticsList = (props) => (
  <CustomerEmailsAnalyticsDataList {...props}/>
);

export const CashbackerCampaignRegistrationsAnalyticsList = (props) => (
  <CashbackerCampaignRegistrationsAnalyticsDataList {...props}/>
);


// WEBPACK FOOTER //
// ./src/containers/CRM/AnalyticsData/index.js